import { render, staticRenderFns } from "./businessDetailSeckill.vue?vue&type=template&id=b9344f0c&scoped=true"
import script from "./businessDetailSeckill.vue?vue&type=script&lang=js"
export * from "./businessDetailSeckill.vue?vue&type=script&lang=js"
import style0 from "./businessDetailSeckill.vue?vue&type=style&index=0&id=b9344f0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9344f0c",
  null
  
)

export default component.exports